import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { requireBackoffice } from '../auth/guard.ts'
import { numericIdParam } from './params.ts'
import { rootRoute } from './root.tsx'

/** A person's card as a link target. `$id` is a person_id — it always was. */
export function personCardLink(personId: number) {
  return { to: '/people/$id', params: { id: personId } } as const
}

export const personDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/people/$id',
  params: numericIdParam,
  beforeLoad: requireBackoffice,
  component: lazyRouteComponent(() => import('../pages/person-detail.tsx')),
})
